import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable, computed, runInAction, action } from 'mobx';
import { Whitespace, Text } from '../common';
import { ReservationTimes } from '../reservation/ReservationTimes';
import buildReservationDays from '../../helpers/resevationTimesHelper';
import moment from 'moment';
import Button from '../common/FormComponents/Button';
import Input, { SelectStyle } from '../common/FormComponents/InputStyle';
import InputHeader from '../common/FormComponents/InputHeader';
import Bro from 'brototype';
import Select from '../common/FormComponents/Select';
import InputStyle from '../common/FormComponents/InputStyle';
import { addTime } from '../../helpers/timeFormatHelpers';
import AddressSelect from '../addresses/AddressSelect';

@observer
class ApproveReservation extends Component {
  @observable changingTimes = true;
  @observable changingPickupAddress = false;
  @observable changingReturnAddress = false;

  @action.bound
  close() {
    if (this.changingPickupAddress) {
      this.changingPickupAddress = false;
    } else if (this.changingReturnAddress) {
      this.changingReturnAddress = false;
    } else {
      this.props.close();
    }
  }

  @action.bound
  async next() {
    if (this.changingTimes) {
      this.changingTimes = false;
    } else if (this.changingPickupAddress) {
      this.changingPickupAddress = false;
    } else if (this.changingReturnAddress) {
      this.changingReturnAddress = false;
    } else {
      const res = await this.props.reservation.approve();
      this.props.close(res);
    }
  }

  @computed
  get nextButtonText() {
    return this.changingTimes ? 'Next' : 'Save';
  }

  @computed
  get editing() {
    return this.changingTimes || this.changingPickupAddress || this.changingReturnAddress;
  }

  @action.bound
  handlePickupAddressChanged(addr) {
    const address = this.props.reservation.pickupAddress;
    address.city.set(addr[0].city);
    address.state.set(addr[0].state);
    address.street.set(addr[0].street);
    address.zipcode.set(addr[0].zipcode);
    address.buildingName.set(addr[0].buildingName);
    this.changingPickupAddress = false;
  }

  @action.bound
  handleReturnAddressChanged(addr) {
    const address = this.props.reservation.returnAddress;
    address.city.set(addr[0].city);
    address.state.set(addr[0].state);
    address.street.set(addr[0].street);
    address.zipcode.set(addr[0].zipcode);
    address.buildingName.set(addr[0].buildingName);
    this.changingReturnAddress = false;
  }

  render() {
    const { reservation, data, messages } = this.props;
    console.log('123@@ rendering dates', this.editing);

    return (
      <div className="f-center-stretch f-rows">
        <div className="primary h4 t-align-center">Approve reservation</div>
        <div className="t-l t-align-center">
          To approve any listings you must set your agreed upon pickup and return times. If you
          don't have these yet then please cancel out and coordinate with the renter to decide upon
          these times.
        </div>
        <Whitespace />
        <div className="">
          {!this.editing && (
            <div>
              <div className="g g-tc-a-3 g-g-m f-align-center f-space-between">
                <Text emphasis>Pickup</Text>
                <Text>
                  {reservation.pickupDayReadable} @ {reservation.pickupTimeReadable}
                </Text>
                <Text align="right" link onClick={() => (this.changingTimes = true)}>
                  Change
                </Text>
              </div>
              <div className="g g-tc-a-3 g-g-m f-align-center f-space-between">
                <Text emphasis>Return</Text>
                <Text>
                  {reservation.returnDayReadable} @ {reservation.returnTimeReadable}
                </Text>
                <Text align="right" link onClick={() => (this.changingTimes = true)}>
                  Change
                </Text>
              </div>
              <Whitespace />
              <Text header>Addresses</Text>
              <Whitespace smaller2 />
              <div className="g g-tc-a-3 g-g-m f-align-center f-space-between">
                <Text emphasis>Pickup</Text>
                <Text>{reservation.pickupAddressStr}</Text>
                <Text align="right" link onClick={() => (this.changingPickupAddress = true)}>
                  Change
                </Text>
              </div>
              <div className="g g-tc-a-3 g-g-m f-align-center f-space-between">
                <Text emphasis>Return</Text>
                <Text>{reservation.returnAddressStr}</Text>
                <Text align="right" link onClick={() => (this.changingReturnAddress = true)}>
                  Change
                </Text>
              </div>
            </div>
          )}
          {data && this.changingTimes && (
            <div>
              <TimeSelection
                date={reservation.checkIn}
                blockedDates={data}
                label="Pickup"
                before
                onDaySelected={reservation.updatePickupDay}
                onTimeSelected={reservation.updatePickupTime}
                messages={messages}
                selectedTime={reservation.pickupTime}
                selectedDay={reservation.pickupDay}
              />
              <TimeSelection
                date={reservation.checkOut}
                blockedDates={data}
                label="Return"
                onDaySelected={reservation.updateReturnDay}
                onTimeSelected={reservation.updateReturnTime}
                messages={messages}
                selectedTime={reservation.returnTime}
                selectedDay={reservation.returnDay}
              />
            </div>
          )}
          {data && this.changingPickupAddress && (
            <div>
              <AddressSelect onSelectionChanged={this.handlePickupAddressChanged} single />
            </div>
          )}
          {data && this.changingReturnAddress && (
            <div>
              <AddressSelect onSelectionChanged={this.handleReturnAddressChanged} single />
            </div>
          )}
        </div>
        <div className="f f-columns f-end-center mt-lx">
          <div>
            <Button muted secondary mr={3} onClick={this.close}>
              Cancel
            </Button>
            <Button secondary disabled={reservation.isInvalid} onClick={this.next}>
              {this.nextButtonText}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

function buildPickerDateStr(date) {
  const mDate = moment(date);
  const calendar = mDate.calendar();
  if (
    calendar.startsWith('Today') ||
    calendar.startsWith('Tomorrow') ||
    calendar.startsWith('Yesterday')
  ) {
    return calendar;
  } else {
    return mDate.format('dddd MMMM Do');
  }
}

@observer
export class TimeSelection extends Component {
  @observable selectedDay;

  componentDidMount() {
    this.selectDay({ target: { value: this.props.date } });
  }

  @computed
  get notes() {
    const { messages = [] } = this.props;
    if (!this.selectedDay) {
      return [];
    }
    return messages.join(' \n');
  }

  @action.bound
  selectDay(e) {
    const { onDaySelected } = this.props;
    this.selectedDay = e.target.value;
    onDaySelected(e.target.value);
  }

  @action.bound
  selectTime(e) {
    const { onTimeSelected } = this.props;
    const val = e.target.value;
    onTimeSelected(val);
  }

  render() {
    const { date, before, blockedDates, selectedTime, selectedDay, label } = this.props;

    const defaultDay = {
      label: 'Day of: ' + buildPickerDateStr(date),
      value: date,
    };
    const otherDay = before ? moment(date).subtract(1, 'days') : moment(date).add(1, 'days');
    const dayOptions = [
      defaultDay,
      {
        label: `Day ${before ? 'before' : 'after'}: ` + buildPickerDateStr(otherDay),
        value: otherDay.format('YYYY-MM-DD'),
      },
    ];

    let currentSelection;
    if (selectedDay) {
      currentSelection = {
        label: buildPickerDateStr(selectedDay),
        value: selectedDay,
      };
      dayOptions.unshift();
    }

    return (
      <div className="g g-tc-fr-2 p-l g-g-mxx">
        <div>
          <Text label>{label}</Text>
          <SelectStyle
            defaultValue={currentSelection || defaultDay}
            onChange={this.selectDay}
            options={dayOptions}
          >
            {dayOptions.map(day => (
              <option value={day.value}>{day.label}</option>
            ))}
          </SelectStyle>
        </div>
        <div className="f f-rows">
          <Text label>{label} Notes</Text>
          <Whitespace smaller2 />
          <div>
            {this.notes.map(x => (
              <li>
                <Text inline noclip>
                  {x}
                </Text>
              </li>
            ))}
          </div>
        </div>
        <div className="f f-rows">
          <Text label>{label} Time</Text>

          <div className="w-150">
            <InputStyle type="time" onChange={this.selectTime} value={selectedTime} />
          </div>
        </div>
      </div>
    );
  }
}

export default ApproveReservation;



// WEBPACK FOOTER //
// ./src/components_new/Inbox/ApproveReservation.js